<template>
    <div @mouseover="activate"
         @mouseout="deactivate"
         class="relative cursor-pointer relative z-10"
    >
        <div class="rounded-full bg-blue-900 w-16 h-16 flex items-center justify-center cursor-pointer relative z-10">
            <span class="relative z-10 rounded-full">
                <i class="fas fa-bullhorn"></i>
            </span>
            <span class="rounded-full bg-red text-white text-xs font-bold py-1 px-2 ml-1" v-if="notifications.length">
                {{ notifications.length }}
            </span>
        </div>

        <div v-show="active"
             v-if="notifications.length"
             class="bg-white p-2 text-black absolute rounded rounded-tr-30 w-112 right-0 top-0 shadow">
            <h4 class="mb-4 uppercase bg-aitems-700 font-thin tracking-wide text-gray-200 p-4 rounded-r-full">
                Notifiche
            </h4>
            <ul class="list-reset text-sm">
                <li v-for="(notification, index) in notifications"
                    :key="notification.id"
                    class="py-4 border-b border-gray bg-white p-1 flex justify-between items-center"
                >
                    <div class="text-aitems-700">
                        <i class="fas fa-comment-alt fa-3x p-1 mr-2"></i>
                    </div>
                    <div>
                        <div class="font-thin tracking-wide text-gray-800">
                            E' stata pubblicata <a :href="`/strings-layouts/${notification.data.stringsLayoutId}`" class="hover:underline">
                            <strong>Revisione {{ notification.data.revision }}</strong></a>
                            della cordiera {{ notification.data.strings_layout_type }}
                            per l'Arpa <strong>{{ notification.data.harpName }}</strong>
                            <span class="text-gray-500 text-xs italic">, {{ notification.created_at | ago }}</span>
                        </div>
                    </div>
                    <div class="block h-full text-gray-700 hover:text-green p-2"
                         @click="markAsRead(notification, index)"
                    >
                        <i class="fas fa-check-circle fa-lg"></i>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import activation from '../mixins/activation';
    import moment from "moment";

    export default {
        mixins: [activation],

        props: ['userId'],

        data() {
            return {
                notifications: {}
            }
        },

        filters: {
            ago: (value) => {
                if (value) {
                    moment.locale('it');
                    return moment(value + 'Z').fromNow();
                }

                return 'Adesso'
            },
        },

        mounted() {
            axios.get('/notifications')
                .then(({data}) => {
                    this.notifications = data;
                });

            window.Echo.private(`Aitems.User.${window.App.user.id}`)
                .notification((notification) => {
                    this.notifications.unshift(notification);
                })
        },

        methods: {
            markAsRead(notification, index) {
                axios.delete(`/notifications/${notification.id}`)
                    .then(() => this.notifications.splice(index, 1))
            }
        }

    }
</script>
